import React, {useCallback} from 'react';
import {useHistory} from "react-router";
import {Grid} from "@material-ui/core";
import {PermissionBlocker} from "../../../lib/permission/components";
import {CardButton} from "../../ui/cards";

export type MenuCardItem = {
  id: string | number;
  title: string;
  img: string;
  path: string;
};

export interface MenuCardList {
  items: MenuCardItem[];
  url: string;
}

export const MenuCardList = ({ items, url }: MenuCardList) => {
  const history = useHistory();

  const onCardClick = useCallback((item: MenuCardItem) => {
    history.push(`${url}${item.path}`);
  }, [history, url]);
  return (
    <Grid container spacing={2}>
      {items.map(item => (
        <PermissionBlocker key={item.id} id={item.id}>
          <Grid item sm={3}>
            <CardButton<MenuCardItem> title={item.title} image={item.img} data={item} onClick={onCardClick} />
          </Grid>
        </PermissionBlocker>
      ))}
    </Grid>
  );
};
